module.exports = __webpack_public_path__ + "img/ring_r_e_1_1@2x.012daf51.png";